<template>
  <div class="new-initiative-activity">
    <activity-header
      :theme-color="themeColor"
      :activity="activity"
      :action-label="actionLabel"
      :award-context="awardContext"
      :show-team-org-name="showTeamOrgName"
      :created-at="activity.createdAt || activity.initiative.createdAt"
      :team-id="teamId"
      @awarded="$emit('awarded')"
      @reacted="$emit('reacted')"
    />
    <div class="meta">
      <activity-entity :project="project" :goal="goal" :activity="activity" v-if="showEntityInfo" />
      <div class="d-flex align-items-center" v-else>
        <b-form-checkbox size="sm" :checked="isDoneAndClosed" :disabled="true"></b-form-checkbox>
        <div class="title flex-grow-1 d-flex">
          <div
            class="d-flex justify-content-between flex-nowrap align-items-center flex-grow-1 overflow-hidden"
          >
            <div class="overflow-hidden d-flex align-items-center">
              <span
                class="text-truncate flex-grow-1"
                :title="activity.initiative.title"
                v-no-capture
                >{{ activity.initiative.title }}</span
              >
              <action-tooltip
                :target="'initiative-expander-' + activity.initiative.id"
                text="Open"
              />
              <span
                class="expander-icon pointer mx-2"
                :id="'initiative-expander-' + activity.initiative.id"
                @click="goToInitiativePage"
                ><i></i
              ></span>
            </div>
          </div>
        </div>
      </div>
      <reactions-list
        class="reactions-list mt-3"
        :event="activity"
        @reacted="$emit('reacted')"
        v-if="areReactionsAvailable"
      />
    </div>
  </div>
</template>

<script>
import ActivityEntity from '@/components/activity/ActivityEntity'
import ReactionsList from '@/components/reactions/ReactionsList'
import { INITIATIVE_EVENT_TYPE } from '@/constants/initiative'
import getEntityAwardContext from '@/utils/getEntityAwardContext'
import handleClickNavigation from '@/utils/handleClickNavigation'
import { getInitiativePageRouteConfig } from '@/utils/navigationConfigs'
import { BFormCheckbox } from 'bootstrap-vue'
import ActionTooltip from '@/components/ActionTooltip'
import ActivityHeader from '@/components/activity/ActivityHeader'
import * as R from 'ramda'

const actionLabelMap = {
  initiative: {
    [INITIATIVE_EVENT_TYPE.CREATED]: 'added an Initiative'
  },
  task: {
    [INITIATIVE_EVENT_TYPE.CREATED]: 'added a Task'
  }
}

/**
 * This components renders view of New Initiative's activity
 */
export default {
  name: 'InitiativeActivity',
  props: [
    'isDoneAndClosed',
    'activity',
    'showEntityInfo',
    'themeColor',
    'showTeamOrgName',
    'goal',
    'project'
  ],
  components: {
    BFormCheckbox,
    ActionTooltip,
    ActivityHeader,
    ReactionsList,
    ActivityEntity
  },
  data() {
    const activityActionLabelMap = this.activity.initiative.parentId
      ? actionLabelMap.task
      : actionLabelMap.initiative
    return {
      awardContext: {
        ...getEntityAwardContext(this.activity.initiative, 'initiative'),
        initiativeId: R.path(['initiative', 'id'], this.activity)
      },
      actionLabel: activityActionLabelMap[this.activity.type]
    }
  },
  methods: {
    goToInitiativePage(event) {
      const initiative = this.activity.initiative
      const location = getInitiativePageRouteConfig({
        orgId: initiative.organizationId,
        initiativeId: initiative.id
      })
      handleClickNavigation.call(this, event, location)
    }
  },
  computed: {
    areReactionsAvailable() {
      return !R.isEmpty(this.activity.reactionSummary)
    },
    teamId() {
      return (this.goal || this.project)?.teamId
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/styleConfigurations';

.title {
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 6px 0;
}

.meta {
  margin-left: 38px;
}
</style>
